import React from "react";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherInfo(props) {
  return (
    <div className="Weatherinfo">
      <h1 className="city mb-3">{props.data.city}</h1>
      <h2 className="tempareture">
        <div className="icon">
          <WeatherIcon
            code={props.data.icon}
            alt={props.data.description}
            size={65}
          />
        </div>
        <div>
          <strong>
            <WeatherTemperature fahrenheit={props.data.temperature} />{" "}
          </strong>
        </div>

        <span className="description">{props.data.description}</span>
      </h2>
      <div className="row condition-panel">
        <div className="col-3">
          <li className="humidity">
            Humidity: <span>{props.data.humidity}</span>%
          </li>
        </div>
        <div className="col-3">
          <li className="wind">
            Wind: <span>{props.data.wind}</span> mph
          </li>
        </div>
        <div className="col-3">
          <li className="Lon">
            Lon: <span>{props.data.longitude}</span>
          </li>
        </div>
        <div className="col-3">
          <li className="Lat">
            Lat: <span>{props.data.latitude}</span>
          </li>
        </div>
      </div>
    </div>
  );
}
